import { RemoteTaskList } from 'data/usecases';
import { makeApiUrlTask } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteTaskList = (): RemoteTaskList => {
  return new RemoteTaskList(makeApiUrlTask(), makeAxiosHttpClient());
};
